import { Link, Text } from '@hotjar/hotsauce';
import { Trans, useTranslation } from 'react-i18next';
import type { Site } from '@hotjar/site';
import { DowngradeMessage as S } from './DowngradeMessage.styles';
import { DISCOVER_MORE_COVERAGE_URL, PRICING_PAGE_URL } from '~/trials/constants';

interface DowngradeMessageProps {
  sites: Site[] | undefined;
}

export const DowngradeMessage = ({ sites }: DowngradeMessageProps): JSX.Element => {
  const { t } = useTranslation('trials', { keyPrefix: 'post-trial' });

  const siteCount = sites?.length ?? 0;

  const PRICING_PAGE_LINK = (
    <Link kind="standalone" href={PRICING_PAGE_URL} isExternal>
      Compare Plans
    </Link>
  );

  const DISCOVER_MORE_LINK = (
    <Link kind="standalone" href={DISCOVER_MORE_COVERAGE_URL} isExternal>
      Discover More
    </Link>
  );

  return (
    <S.MessageContainer>
      <Text as="p" textType="body1">
        <Trans
          i18nKey="trials:post-trial.subscribe-or-downgrade"
          components={[<Text textType="subtitle1" />]}
          count={siteCount}
        >
          {t('subscribe-or-downgrade', { count: siteCount })}
        </Trans>
      </Text>
      <ul>
        <Text as="li" textType="body2">
          <Trans i18nKey="trials:post-trial.coverage-benefits" components={[DISCOVER_MORE_LINK]}>
            {t('coverage-benefits')}
          </Trans>
        </Text>
        <Text as="li" textType="body2">
          <Trans i18nKey="trials:post-trial.compare-plans" components={[PRICING_PAGE_LINK]}>
            {t('compare-plans')}
          </Trans>
        </Text>
      </ul>
      <S.Alert kind="info">{t('data-capture-info')}</S.Alert>
    </S.MessageContainer>
  );
};
